<div class="content message-position" role="main">
    <h1>404 </h1>
<div>
<h2>{{'CP_LM_DEFAULTPAGE_MESSAGE' | customTranslation: translationData }}</h2>

</div>
</div>
